import { render } from "./MyLogo.vue?vue&type=template&id=dee77274&scoped=true"
import script from "./MyLogo.vue?vue&type=script&lang=js"
export * from "./MyLogo.vue?vue&type=script&lang=js"

import "./MyLogo.vue?vue&type=style&index=0&id=dee77274&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee77274"]])

export default __exports__